<template>
  <div style="overflow:hidden; position:relative">
    <v-row>
      <v-col cols="12" md="7" class="mx-auto">
        <p class="display-1 font-weight-bold primary--text pt-8 pb-4">
          Ficha de especie
        </p>
        <LibraryItem :id-organism="idOrganism" v-if="idOrganism" />
      </v-col>
    </v-row>
    <v-img :src="jureles" height="200" full-width></v-img>
    <v-img
      :src="congrio_colorado"
      height="400"
      width="600"
      contain
      style="position: absolute; top: 400px; left: -250px; filter: opacity(20%); transform: scaleX(-1)"
    ></v-img>
    <v-img
      :src="apanado"
      height="400"
      width="600"
      contain
      style="position: absolute; top: 100px; right: -250px; filter: opacity(20%)"
    ></v-img>
  </div>
</template>

<script>
import LibraryItem from "../components/Library/LibraryItem";

export default {
  components: {
    LibraryItem
  },
  data: () => ({
    idOrganism: null,
    jureles: require("@/assets/landing/jureles.jpg"),
    congrio_colorado: require("@/assets/congrio_colorado.png"),
    apanado: require("@/assets/apanado.png")
  }),
  mounted() {
    this.idOrganism = this.$route.params.id;
  }
};
</script>
